import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  upperModelIndex: 0,
  lowerModelIndex: 0,
  showUpperModel: true,
  showLowerModel: true,
  upperAngel: false,
  leftAngle: false,
  rightAngle: false,
  lowerAngle: false,
  frontAngle: true,
  meshed: false,
  showIpr: true,
  position: { position: [0, 35, 250], fov: 25 },
  patientDetails: null,
  iprDetails: [],
  attachtmentDetails: [],
  lowerAlignerFiles: [],
  upperAlignerFiles: [],
  noOfUpperAligners: 0,
  noOfLowerAligners: 0,
  modelsRemaining: 0,
  progress: 2,
  loading: true,
  iprAnimation: false,
};

const modelSlice = createSlice({
  name: "model",
  initialState,
  reducers: {
    setUpperModelIndex: (state, action) => {
      state.upperModelIndex = action.payload;
    },
    setLowerModelIndex: (state, action) => {
      state.lowerModelIndex = action.payload;
    },
    toggleUpperModel: (state, action) => {
      state.showUpperModel = action.payload;
    },
    toggleLowerModel: (state, action) => {
      state.showLowerModel = action.payload;
    },
    setPosition: (state, action) => {
      state.position = action.payload;
    },
    setUpperAngle: (state, action) => {
      state.showUpperModel = true;
      state.showLowerModel = false;
      state.upperAngle = action.payload;
      state.leftAngle = !action.payload;
      state.rightAngle = !action.payload;
      state.lowerAngle = !action.payload;
      state.frontAngle = !action.payload;
    },
    setLeftAngle: (state, action) => {
      state.showUpperModel = true;
      state.showLowerModel = true;
      state.upperAngle = !action.payload;
      state.leftAngle = action.payload;
      state.rightAngle = !action.payload;
      state.lowerAngle = !action.payload;
      state.frontAngle = !action.payload;
    },
    setRightAngle: (state, action) => {
      state.showUpperModel = true;
      state.showLowerModel = true;
      state.upperAngle = !action.payload;
      state.leftAngle = !action.payload;
      state.rightAngle = action.payload;
      state.lowerAngle = !action.payload;
      state.frontAngle = !action.payload;
    },
    setLowerAngle: (state, action) => {
      state.showUpperModel = false;
      state.showLowerModel = true;
      state.upperAngle = !action.payload;
      state.leftAngle = !action.payload;
      state.rightAngle = !action.payload;
      state.lowerAngle = action.payload;
      state.frontAngle = !action.payload;
    },
    setFrontAngle: (state, action) => {
      state.showUpperModel = true;
      state.showLowerModel = true;
      state.upperAngle = !action.payload;
      state.leftAngle = !action.payload;
      state.rightAngle = !action.payload;
      state.lowerAngle = !action.payload;
      state.frontAngle = action.payload;
    },
    toggleMeshed: (state) => {
      state.meshed = !state.meshed;
    },
    setPatientDetails: (state, action) => {
      state.patientDetails = action.payload;
    },
    setIprDetails: (state, action) => {
      state.iprDetails = action.payload;
    },
    setAttachmentDetails: (state, action) => {
      state.attachtmentDetails = action.payload;
    },
    setLowerAlignerFiles: (state, action) => {
      state.lowerAlignerFiles = action.payload;
    },
    setUpperAlignerFiles: (state, action) => {
      state.upperAlignerFiles = action.payload;
    },
    setNoOfUpperAligners: (state, action) => {
      state.noOfUpperAligners = action.payload;
    },
    setNoOfLowererAligners: (state, action) => {
      state.noOfLowerAligners = action.payload;
    },
    toggleIpr: (state, action) => {
      state.showIpr = !state.showIpr;
    },
    setModelsRemaining: (state, action) => {
        state.modelsRemaining = action.payload
    },
    setProgress: (state, action) => {
        state.progress = action.payload
    },
    setLoading: (state, action) => {
        state.loading = action.payload
    },
    toggleAnimation: (state, action) => {
      state.iprAnimation = action.payload;
    },
  },
});

export const {
  setUpperModelIndex,
  setLowerModelIndex,
  toggleUpperModel,
  toggleLowerModel,
  setPosition,
  setUpperAngle,
  setLeftAngle,
  setRightAngle,
  setLowerAngle,
  setFrontAngle,
  toggleMeshed,
  setPatientDetails,
  setIprDetails,
  setAttachmentDetails,
  setLowerAlignerFiles,
  setUpperAlignerFiles,
  setNoOfUpperAligners,
  setNoOfLowererAligners,
  toggleIpr,
  setModelsRemaining,
  setProgress,
  setLoading,
  toggleAnimation,

} = modelSlice.actions;

export default modelSlice.reducer;
